import StyledMapType from "./StyledMapType";
import light from "./light";
import MapTypeId from "./MapTypeId";
const defaultOptions = {
  mapTypeId: MapTypeId.LIGHT
};
class LightMapType extends StyledMapType {
  constructor(options = {}) {
    super(light, {
      ...defaultOptions,
      ...options
    });
  }
}
export default LightMapType;